import { Tag } from "@/store/modules/tag";
import { DefineComponent, ref, watch, computed } from "vue";
import { onBeforeRouteUpdate, RouteRecordRaw, useRouter } from "vue-router";
import { useStore } from "vuex";

export interface RealIframeList {
  name: string;
  value: string;
  meta: {
    iframeComponent?: DefineComponent;
  };
}

export default () => {
  const router = useRouter();
  const store = useStore();
  console.log(store, "storestorestorestorestorestore");

  const reloadIframe = computed(() => store.getters.getReloadIframe);
  const iframeList = router.getRoutes().filter((item) => item.meta.iframeComponent);
  const arr = new Set(iframeList.map((item) => item.name));

  const realIframeList = ref([] as RealIframeList[]);
  watch(reloadIframe, (bol) => {
    console.log(bol, "reloadIframe");

    //为true时调用
    if (bol) {
      effectList();
      store.commit("SET_CURRENT_RELOADIFRAME", false);
    }
  });
  // 刷新
  const effectList = () => {
    const lists = store.getters.getAliveList.filter((item: Tag) => arr.has(item.name));
    realIframeList.value = [];
    lists.forEach((list: Tag) => {
      const { meta } = iframeList.find((item) => list.name == item.name) as RouteRecordRaw;
      if (meta) realIframeList.value.push({ ...list, meta });
    });
  };
  onBeforeRouteUpdate((to: any, form) => {
    if (to.params.id == form.params.id) {
      // 需延迟执行,否则得不到信息
      setTimeout(effectList);
    }
  });
  return { realIframeList, effectList };
};
